import { homepageFAQContent, homepageHeroContent, reviewsContent, rtbWithImagesSectionContent, socialContent, startingFreshContent, treatsAndExtrasFeaturetteContent, waysToNomContent, whyNomNomFeaturetteContent, } from '@marketing/components/sections/content';
var homepageContent = {
    sections: {
        homepageHeroContent: homepageHeroContent,
        whyNomNomFeaturetteContent: whyNomNomFeaturetteContent,
        rtbWithImagesSectionContent: rtbWithImagesSectionContent,
        startingFreshContent: startingFreshContent,
        waysToNomContent: waysToNomContent,
        treatsAndExtrasFeaturetteContent: treatsAndExtrasFeaturetteContent,
        reviewsContent: reviewsContent,
        homepageFAQContent: homepageFAQContent,
        socialContent: socialContent,
    },
    seoSchemaJson: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Nom Nom',
        'url': 'https://www.nomnomnow.com/',
        'logo': 'https://www.nomnomnow.com/static/dist/images/logo/nom_nom_straight.35a5de21943465fcb861.svg',
        'sameAs': [
            'https://www.facebook.com/GetNomNom/',
            'https://www.instagram.com/nomnom/',
            'https://x.com/nom_nom_now',
            'https://www.youtube.com/c/nomnomnow',
        ],
        'contactPoint': {
            '@type': 'ContactPoint',
            'telephone': '+1-415-991-0669',
            'contactType': 'customer service',
            'areaServed': 'US',
        },
        'address': {
            '@type': 'PostalAddress',
            'addressLocality': 'Nashville',
            'addressRegion': 'TN',
            'addressCountry': 'US',
        },
        'website': {
            '@type': 'WebSite',
            'url': 'https://www.nomnomnow.com/',
        },
    },
};
export default homepageContent;
